/**
 * auth 模块处理登录授权相关的接口
 * @module auth
 */

import request from '@/base/network/request';
import { getToken, setToken } from '@/base/store/auth';
import { getStorage } from '@/base/store/storage';
import { getDeviceId } from '@/utils/device';

/**
 * 获取用户是否登录
 * @method hasLogin
 * @return {Boolean} true-登录 false-未登录
 */
export function hasLogin () {
  return !!getToken();
}

/**
 * 登录
 * @method login
 */
let loginLock = false; // 防止并发

export async function login () {
  if (loginLock) return Promise.resolve(null);
  loginLock = true;

  try {
    const device_id = await getDeviceId();
    const mobile = getStorage('mobile') || '';
    const externalParams = getStorage('external_params') || '';

    const res = await request({
      url: '/overseas-h5/auth/login',
      method: 'POST',
      data: { device_id, mobile, external_params: externalParams },
      timeout: 2000,
    });

    const token = res?.data?.info?.token;
    if (!token) throw new Error('Login response missing token');

    setToken(token);

    return token;
  } catch (err) {
    console.error('login failed:', err);
    // login 失败时不要抛出，让调用者决定下一步动作
    return null;
  } finally {
    loginLock = false;
  }
}
